$(function() {
   var count = 250;
 $('.search .content p').each(function() {
     var thisText = $(this).text();
      var textLength = thisText.length;
       if (textLength > count) {
          var showText = thisText.substring(0, count);
          var insertText = showText += '…';
          $(this).html(insertText);
      };
  });
});